/**
 * @method: to call reducer
 */
 import { actionType } from "../footer/action"; 
  const reducer = (state = {}, action) => {
    switch (action.type) {
      case actionType.GET_FOOTER_MENUS:
           return { ...state };
      case actionType.FOOTER_MENUS_RECEIVED:
           return { ...state, ...action.payload}
      default: 
           return state;
    }
   };
   export default reducer;